import api from 'api';

const url = id => `api/payments/${id}/pay/svea-webpay`;

export default {
    webPay: id => api.get({path: url(id)})
}